import { Skeleton } from "@mui/material";
import type { PropsWithChildren, ReactNode } from "react";
import PageTitle from "./PageTitle";

interface PageTitleProps extends PropsWithChildren {
  noBackButton?: boolean;
}

function PageTitleSkeleton({
  noBackButton = false,
  children,
}: Readonly<PageTitleProps>): ReactNode {
  return (
    <PageTitle
      noBackButton={noBackButton}
      title={
        <Skeleton
          variant="text"
          animation="wave"
          sx={{ height: "50px", width: { xs: "50%", md: 500 } }}>
          {children}
        </Skeleton>
      }
    />
  );
}

export default PageTitleSkeleton;
